import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { CalendarIcon, XIcon, ChevronUpIcon, PhoneIcon } from 'lucide-react';
import { WhatsAppLogo } from './icons/WhatsAppLogo';
export const FixedCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  useEffect(() => {
    // Check if device is mobile
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    // Show the CTA after user has scrolled a bit
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    // Initial check for mobile
    checkMobile();
    // Initial check for scroll position
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', checkMobile);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', checkMobile);
    };
  }, []);
  if (!isVisible) return null;
  // Mobile version
  if (isMobile) {
    return <div className="fixed bottom-0 left-0 right-0 z-50 animate-fadeIn" data-id="element-143">
        {/* Main CTA Bar */}
        <div className="bg-black/90 backdrop-blur-md border-t border-[#222] shadow-lg px-4 py-3 flex items-center justify-between" data-id="element-144">
          {/* Afspraak maken button with gradient animation */}
          <Link to="/afspraak-maken" className="relative overflow-hidden rounded-md flex-1 mr-3" data-id="element-145">
            <div className="bg-gradient-to-r from-[#FFD500] via-[#FF6B00] to-[#D6281F] py-2.5 px-5 text-center animate-gradient-shift" data-id="element-146">
              <span className="text-black font-medium text-sm uppercase" data-id="element-147">
                Afspraak maken
              </span>
            </div>
          </Link>
          {/* Contact buttons container */}
          <div className="flex items-center space-x-2" data-id="element-148">
            {/* WhatsApp Button */}
            <a href="https://wa.me/31627888306" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-md bg-[#25D366] flex items-center justify-center shadow-md" aria-label="Contact via WhatsApp" data-id="element-149">
              <WhatsAppLogo size={20} data-id="element-150" />
            </a>
            {/* Phone Button */}
            <a href="tel:+31627888306" className="w-10 h-10 rounded-md bg-[#121212] border border-[#333] flex items-center justify-center" aria-label="Call us" data-id="element-151">
              <PhoneIcon size={18} className="text-white" data-id="element-152" />
            </a>
          </div>
        </div>
      </div>;
  }
  // Desktop version
  return <div className="fixed bottom-6 right-6 z-50 animate-fadeIn" data-id="element-153">
      {isExpanded ? <div className="bg-black/90 backdrop-blur-md border border-[#333] rounded-md shadow-xl overflow-hidden w-64" data-id="element-154">
          <div className="flex items-center justify-between p-3 border-b border-[#222]" data-id="element-155">
            <h3 className="text-white font-medium text-sm" data-id="element-156">Contact opties</h3>
            <button onClick={() => setIsExpanded(false)} className="text-white/60 hover:text-white p-1.5 rounded-md hover:bg-white/10 transition-all" aria-label="Close contact options" data-id="element-157">
              <XIcon size={16} data-id="element-158" />
            </button>
          </div>
          <div className="p-4 space-y-3" data-id="element-159">
            <Link to="/afspraak-maken" className="relative overflow-hidden rounded-md block" data-id="element-160">
              <div className="bg-gradient-to-r from-[#FFD500] via-[#FF6B00] to-[#D6281F] py-2.5 px-4 text-center animate-gradient-shift" data-id="element-161">
                <span className="text-black font-medium text-sm" data-id="element-162">
                  Afspraak maken
                </span>
              </div>
            </Link>
            <a href="https://wa.me/31627888306" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center bg-[#25D366] hover:bg-[#25D366]/90 text-white font-medium text-sm py-2.5 px-4 rounded-md text-center transition-colors duration-300" data-id="element-163">
              <WhatsAppLogo size={16} className="mr-2" data-id="element-164" />
              WhatsApp
            </a>
            <Link to="/contact" className="block bg-[#121212] hover:bg-[#1a1a1a] text-white font-medium text-sm py-2.5 px-4 rounded-md text-center transition-colors duration-300 border border-[#333]" data-id="element-165">
              Vraag advies
            </Link>
          </div>
        </div> : <button onClick={() => setIsExpanded(true)} className="relative overflow-hidden rounded-md p-3 shadow-lg hover:shadow-[0_0_15px_rgba(214,40,31,0.3)] transition-all duration-300 group" aria-label="Open contact options" data-id="element-166">
          <div className="bg-gradient-to-r from-[#FFD500] via-[#FF6B00] to-[#D6281F] absolute inset-0 animate-gradient-shift" data-id="element-167"></div>
          <ChevronUpIcon size={20} className="relative z-10 text-black group-hover:animate-bounce" data-id="element-168" />
        </button>}
    </div>;
};